import { useRef } from "react";
import { ButtonAccessability } from "components/Elements/Button/Button.js";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useUploaderInput } from "../../Helpers/useUploaderInput.js";
import styles from "./styles.module.scss";

export const UploaderFilesButtons = () => {
  const { getTextByKey } = useContent();
  const { getUploading } = useUploader();

  const filesRef = useRef();
  const folderRef = useRef();

  const { handleAddFiles, handleAddFolders } = useUploaderInput({
    filesRef,
    folderRef,
  });

  return getUploading() ? null : (
    <div className={styles.wrap}>
      <ButtonAccessability buttonClassName={styles.addMore}>
        <Icon iconClass={styles.moreIcon} name={"add_more_files"} />
        {getTextByKey("add-more-files")}
      </ButtonAccessability>
      <div className={styles.ui}>
        <ButtonAccessability
          onClick={handleAddFiles}
          buttonClassName={styles.filesButton}
        >
          <Icon iconClass={styles.icon} name={"home/add_files"} />
          {getTextByKey("add-files-uploader")}
        </ButtonAccessability>
        <ButtonAccessability
          onClick={handleAddFolders}
          buttonClassName={styles.filesButton}
        >
          <Icon iconClass={styles.icon} name={"home/add_folder"} />
          {getTextByKey("add-folder-uploader")}
        </ButtonAccessability>
        <div className={styles.hidden}>
          <input type="file" className="files-input" ref={filesRef} multiple />
          <input
            type="file"
            className="folders-input"
            aria-hidden="true"
            //@ts-ignore
            webkitdirectory=""
            directory=""
            multiple
            ref={folderRef}
          ></input>
        </div>
      </div>
    </div>
  );
};
